/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Jump_TitleInputs */

const en_features_jump_title = /** @type {(inputs: Features_Jump_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jump to the part you want to listen to`)
};

const es_features_jump_title = /** @type {(inputs: Features_Jump_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salta a la parte que quieras escuchar`)
};

/**
* | output |
* | --- |
* | "Jump to the part you want to listen to" |
*
* @param {Features_Jump_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const features_jump_title = /** @type {((inputs?: Features_Jump_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Jump_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_features_jump_title(inputs)
	return en_features_jump_title(inputs)
});